// extracted by mini-css-extract-plugin
module.exports = {"body":"ResubCard_body__1u3d4","status":"ResubCard_status__28EMp","msg":"ResubCard_msg__Xta3n"};